export { SocialMediaTable } from './SocialMediaTable';
export * from './SocialMediaTable.types';
